const path = '/img/products/portrait-segmentation';

/**
 * BANNER_DATA
 * buttonText 和 buttonLink 一一对应，默认是string，可以是是array；当是array时，渲染多个button
 */
export const BANNER_DATA = {
  title: '人像分割',
  backgroundImg: `${path}/banner.webp`,
  description:
    '识别图像中的人体轮廓，将其与背景分离，可应用于人体特效制作、图像处理、视频会议虚拟背景等场景',
  buttonText: '申请试用',
  buttonLink: '',
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  links: [
    // { name: 'Demo体验', link: '' },
  ],
};
export const ADVANTAGES_EFFECT = [
  {
    title: '适配多种场景',
    content: '支持多人、部分肢体、远近人像、任意角度、遮挡、复杂光照等多种环境',
    picUrl: `${path}/icon1.webp`,
  },
  {
    title: '高精度',
    content: '人像边缘处理精细、过渡自然',
    picUrl: `${path}/icon2.webp`,
  },
  {
    title: '高稳定性',
    content: '视频处理时人像前景稳定性高、不抖动',
    picUrl: `${path}/icon3.webp`,
  },
  {
    title: '全机型覆盖',
    content: '全机型覆盖实时处理',
    picUrl: `${path}/icon4.webp`,
  },
];

export const FEATURES = [
  {
    title: '图像/视频人像分割',
    content: '将图片/视频中的人像区域与背景分离，支持多人及复杂人体姿态场景',
    picUrl: `${path}/3d-icon1.webp`,
    // 注意：这里图片的属性名imgUrl和picUrl pc端显示效果有区别
  },
  {
    title: '实时人像分割',
    content: '支持实时拍摄场景将人像轮廓与背景分离',
    picUrl: `${path}/3d-icon2.webp`,
  },
];

export const DEMO_DATA = {
  title: '功能演示',
  items: [
    {
      before: `${path}/example-1-b.webp`,
      after: `${path}/example-1-a.webp`,
    },
    {
      before: `${path}/example-2-b.webp`,
      after: `${path}/example-2-a.webp`,
    },
    {
      before: `${path}/example-3-b.webp`,
      after: `${path}/example-3-a.webp`,
    },
    {
      before: `${path}/example-4-b.webp`,
      after: `${path}/example-4-a.webp`,
    },
  ],
  mobileDemos: [`${path}/demo1-mobile.webp`],
};

export const SCENARIO_EFFECT = [
  {
    title: '视频会议虚拟背景',
    content: '视频会议对参会者背景进行替换或虚拟化处理，保护参会者隐私',
    picUrl: `${path}/scene-1.webp`,
    picHoverUrl: '',
  },
  {
    title: '背景替换',
    content: '精准分割图像中人像区域，分割后将人像融合到自定义背景中',
    picUrl: `${path}/scene-2.webp`,
    picHoverUrl: '',
  },
  {
    title: '智能字幕遮挡',
    content: '用户观看视频时，将弹幕隐藏在人体后，提升用户观看体验',
    picUrl: `${path}/scene-3.webp`,
    picHoverUrl: '',
  },
  {
    title: '证件照制作',
    content: '将人像分割出来放置于指定纯色背景下，完成证件照背景色更换',
    picUrl: `${path}/scene-4.webp`,
    picHoverUrl: '',
  },
];
